import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import {
  getLastMatchFlow,
} from '../../api/matchFlowApi';

type useGetLastMatchFlowResponse = {
  data: MatchFlowResponse,
  isError: boolean,
  isLoading: boolean,
  error: AxiosError | null,
  refetch: () => void,
}
export const useGetLastMatchFlow = (
  accountId: string,
  positionId: string,
):useGetLastMatchFlowResponse => {
  const {
    isError,
    error,
    data,
    isLoading,
    refetch,
  } = useQuery<MatchFlowResponse, AxiosError | null>(
    ['match-flow', accountId, positionId],
    () => {
      return getLastMatchFlow(accountId, positionId);
    },
    {
      refetchInterval: 5000, // todo: change to 1-minute
    });

  return {
    isError,
    error,
    data: data as MatchFlowResponse,
    isLoading,
    refetch,
  };
};
